import React, { useMemo } from "react";
import { ChildrenProps } from "../../types";
import { FinancialAccountsConnectionContext } from "./FinancialAccountsConnectionContext";

interface FinancialAccountsConnectionProviderProps extends ChildrenProps {
    showAccountTypeWarning: boolean;
}

export const FinancialAccountsConnectionProvider: React.FC<
    FinancialAccountsConnectionProviderProps
> = ({ children, showAccountTypeWarning }) => {
    const value = useMemo(
        () => ({
            showAccountTypeWarning,
        }),
        [showAccountTypeWarning],
    );

    return (
        <FinancialAccountsConnectionContext.Provider value={value}>
            {children}
        </FinancialAccountsConnectionContext.Provider>
    );
};
